import React from 'react';
import classNames from 'classnames';

import { ArrowIcon } from 'features/order-tracker/shared-components/svg';
import {
  ANALYTICS_APPT_NEXT_MONTH,
  ANALYTICS_APPT_PREVIOUS_MONTH,
} from './constants';

import styles from './styles.module.scss';

export const MonthSelector: React.FC<components.MonthSelectorProps> = (props) => {
  const {
    pickNewMonth,
    monthOffset,
    monthInfo: {
      year,
      month,
    },
  } = props;

  return (
    <div className={styles.monthSelectorContainer}>
      <button
        className={classNames(styles.prevButton, { [styles.hidden]: !monthOffset })}
        onClick={() => pickNewMonth(false)}
        type="button"
        data-analytics-link={ANALYTICS_APPT_PREVIOUS_MONTH}
        disabled={!monthOffset}
        aria-label='back'
      >
        <ArrowIcon height={28} width={28} />
      </button>
      <h4>{`${month} ${year}`}</h4>
      <button
        className={classNames(styles.nextButton, { [styles.hidden]: monthOffset === 3 })}
        onClick={() => pickNewMonth(true)}
        type="button"
        disabled={monthOffset === 3}
        data-analytics-link={ANALYTICS_APPT_NEXT_MONTH}
        aria-label='forward'
      >
        <ArrowIcon height={28} width={28} />
      </button>
    </div>
  );
};
